import { Component, OnInit, ChangeDetectorRef, ViewChild, TemplateRef, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppModule } from '../../../../app-module';
import { EnrollmentMovements, estatusSolicitudRegistroRequest, estatusSolicitudRegistroResponse, getBitacoraEstatusResponse, sendEmailRequest, sendEmailResponse, sendEmailValidacionRequest, sendEmailValidacionResponse, Service } from './service';
import { BaseReponseGeneric } from '../../../../commons/class/BaseReponseGeneric.interface';
import { Observable, of } from 'rxjs';
import { Documents } from '../../../../commons/class/archivo.inteface';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ListaArchivosComponent } from '../../../../commons/components/downLoadFile/lista-archivos/lista-archivos.component';
import { AlertService } from '../../../../commons/components/alert/alert.service';
import { AlertComponent } from '../../../../commons/components/alert/alert.component';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as ExcelJS from 'exceljs';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../../commons/services/auth.service';
import { OajDictaminacionPositivaComponent } from '../oaj-dictaminacion-positiva-component/oaj-dictaminacion-positiva-component';
import { IpService } from '../../../../commons/services/ipService.service';


@Component({
    selector: 'oaj-reporte',
    imports: [AppModule, ListaArchivosComponent, AlertComponent, OajDictaminacionPositivaComponent],
    templateUrl: './reporte.html',
    styleUrls: ['./reporte.css'],
    providers: [AuthService]
})
export class Reporte implements OnInit {

    idUsuaurio!: number;
    formulario!: FormGroup;
    fechaAyer: Date = new Date();
    fechaActual: Date = new Date();
    datos: Observable<EnrollmentMovements[]> = of([]);
    tipoReporteSeleccionado!: number;
    archivosModal: Documents[] = [];
    archivosModalError = '';
    archivosModalLoading = false;
    @ViewChild('modalArchivos') modalArchivosTpl?: TemplateRef<any>;
    @ViewChild('modalDictaminacion') modalDictaminacionTpl?: TemplateRef<any>;
    @ViewChild('modalRevision') modalRevisionRegistrosPrendientes?: TemplateRef<any>;
    @ViewChild('modalValPendiente') modalValPendiente?: TemplateRef<any>;
    @ViewChild('modalBitacoraEstatus') modalBitacoraEstatus?: TemplateRef<any>;
    @ViewChild('modalMotivoDictaminacion') modalMotivoDictaminacion?: TemplateRef<any>;
    motivoDictaminacion: string | null = null;
    idMovimientoAutoEnrolamiento!: number;
    datosExport: any[] = []
    loading = false;
    isGridVisible = true;
    idMovAutoEnrolamientoRevision!: number;
    private modalRef?: NgbModalRef;
    bitacoraEstatus: getBitacoraEstatusResponse[] = [];
    private ip = '';

    private activatedRoute = inject(ActivatedRoute);
    public token: string | null = null;
    public empleadoId: number | null = null;

    private fb: FormBuilder = inject(FormBuilder);
    private service: Service = inject(Service);
    private changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
    private modalService: NgbModal = inject(NgbModal);
    private alertService: AlertService = inject(AlertService);
    private authService: AuthService = inject(AuthService);
    private ipService = inject(IpService);

    constructor() {
        this.fechaAyer = new Date(this.fechaAyer.setDate(new Date().getDate() - 1));
        this.formulario = this.fb.group({
            fechaInicio: this.fb.control({ value: this.toDateInputValue(this.fechaAyer), disabled: false }, []),
            fechaFin: this.fb.control({ value: this.toDateInputValue(this.fechaActual), disabled: false }, []),
            tipo: this.fb.control({ value: 1, disabled: false }, []),
            filtroGeneral: this.fb.control({ value: null, disabled: false }, []),
            folio: this.fb.control({ value: null, disabled: false }, []),
        });
    }

    ngOnInit(): void {

        this.idUsuaurio = this.authService.getIdUser();
        //const orgn = this.authService.getIdOrgan();

        this.buscar();
        this.ipService.getIPAddressPromise().then(
            (response) => {
                this.ip = response;
                // console.log('IP obtenida:', this.ip);
            }
        );
    }

    /**
     * Función para buscar movimientos de auto enrolamiento según los filtros seleccionados, se validan los campos del formulario, se formatean las fechas al formato esperado por el backend, se obtiene el tipo de reporte seleccionado y se llama al método correspondiente del servicio para obtener los movimientos filtrados, si la consulta es exitosa se asignan los datos a la propiedad datos y se muestra un mensaje de éxito, si ocurre un error durante la consulta se muestra un mensaje de error
     * @returns 
     */
    buscar() {

        if (this.formulario.invalid) { return; }
        this.loading = true;
        this.datos = of([]);

        const fechaInicio: Date = new Date(this.formulario.controls['fechaInicio'].value.replace(/-/g, '/'));
        const fechaFin: Date = new Date(this.formulario.controls['fechaFin'].value.replace(/-/g, '/'));
        this.tipoReporteSeleccionado = this.formulario.controls['tipo'].value;


        this.service.getMovAutoEnrolamiento(this.toDateInputValue(fechaInicio),
            this.toDateInputValue(fechaFin),
            this.tipoReporteSeleccionado)
            .subscribe((x: BaseReponseGeneric<EnrollmentMovements[]>) => {
                if (x.succcess) {
                    this.loading = false;
                    this.datosExport = x.data ?? [];
                    this.datos = of(x.data ?? []);
                    if (!x.data || x.data.length === 0) { this.alertService.info('No se encontraron registros', { autoClose: true }); }
                    this.changeDetectorRef.detectChanges();
                }
                else {
                    this.loading = false;
                    this.datos = of(x.data ?? []);
                    this.alertService.error(x.message, { autoClose: true, keepAfterRouteChange: false });
                     this.changeDetectorRef.detectChanges();
                }
            });


    }

    /**
     * Función para convertir una fecha a un valor de entrada de tipo fecha (YYYY-MM-DD)
     * @param date 
     * @returns 
     */
    private toDateInputValue(date: Date): string {
        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        const day = `${date.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    /**
     * Función para abrir el modal de documentos, se obtiene el ID del tipo de archivo según el tipo de reporte seleccionado y se llama al método obtenerDocumentosAutoEnrolamiento del servicio para obtener los documentos asociados al movimiento
     * @param idMovAutoEnrolamiento 
     */
    abrirModal(idMovAutoEnrolamiento: number): void {

        this.archivosModal = [];
        this.archivosModalError = '';
        this.archivosModalLoading = true;

        // Usar setTimeout para evitar ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
            this.modalService.open(this.modalArchivosTpl, {
                size: 'xl',
                backdrop: 'static',
                keyboard: false,
            });

            this.service
                .obtenerDocumentosAutoEnrolamiento(idMovAutoEnrolamiento, 240)
                .subscribe({
                    next: (archivos) => {
                        this.archivosModal = archivos ?? [];
                        this.archivosModalLoading = false;
                        this.changeDetectorRef.detectChanges();
                    },
                    error: () => {
                        this.archivosModalError =
                            'Ocurrio un error al cargar los archivos.';
                        this.archivosModalLoading = false;
                        this.changeDetectorRef.detectChanges();
                    },
                });
        });
    }

    /**
     * Función para abrir el modal de documentos de aceptación, se obtiene el ID del tipo de archivo y se llama al método obtenerDocumentosAutoEnrolamiento del servicio para obtener los documentos asociados al movimiento
     * @param idMovAutoEnrolamiento 
     */
    abrirModalDocumentoAceptacion(idMovAutoEnrolamiento: number): void {

        this.archivosModal = [];
        this.archivosModalError = '';
        this.archivosModalLoading = true;

        this.modalService.open(this.modalArchivosTpl, {
            size: 'xl',
            backdrop: 'static',
            keyboard: false,
        });

        this.service
            .obtenerDocumentosAutoEnrolamiento(idMovAutoEnrolamiento, 241)
            .subscribe({
                next: (archivos) => {
                    this.archivosModal = archivos ?? [];
                    this.archivosModalLoading = false;
                },
                error: () => {
                    this.archivosModalError =
                        'Ocurrio un error al cargar el documento de aceptacion.';
                    this.archivosModalLoading = false;
                },
            });
    }



    /**
     * Función para preparar los datos de exportación, se construyen las columnas y filas según el tipo de reporte seleccionado, se formatean los datos para que sean legibles en el reporte, y se retorna un objeto con las columnas y filas listas para exportar
     * @returns 
     */
    private prepararDatosParaExportar(): { columnas: any[], filas: any[][] } {
        // columnas base (siempre presentes)
        const columnasBase = [
            {titulo: 'Número de solicitud'},
            {titulo: 'Entidad'},
            {titulo: 'Dependencia'},
            {titulo: 'Autoridad'},
            {titulo: 'Solicitante'},
            {titulo: 'Datos de contacto',
                subcolumnas: [
                    {titulo: 'Correo Oficial de la Institución'},
                    {titulo: 'Correo Oficial del Solicitante'},
                    {titulo: 'Teléfono Institucional del Solicitante'}
                ]
            },
            {titulo: 'Observaciones Capturadas en la Solicitud'},
            {titulo: 'Documentos'},
            {titulo: 'Estatus'}
        ];

        let columnasExtra: any[] = [];

        // columnas adicionales según tipoReporteSeleccionado
        const tipo = Number(this.tipoReporteSeleccionado);

        if (tipo !==5){
            columnasBase.splice(columnasBase.length - 1, 0, {titulo: 'Fecha Recepción de Solicitud'}); 
        }

        switch (tipo) {
            case 1:
            case 4:
                columnasExtra = [{titulo: 'Usuario revisor'}];  //, 'Emitir Dictaminación (Rechazada - Aceptada)'];
                break;
            case 2:
                columnasExtra = [
                    {titulo: 'Sentido Dictaminación'}, 
                    {titulo: 'Fecha Dictaminación'},
                    {titulo: 'Usuario Dictaminador'}, 
                    //{titulo: 'Documento de Aceptación Autoridad'}
                ];
                break;
            case 0:
                columnasExtra = [
                    {titulo: 'Sentido Dictaminación'}, 
                    {titulo: 'Fecha Dictaminación'},
                    {titulo: 'Usuario Revisor / Dictaminador'}
                ]; //, 'Documento de Aceptación Autoridad'];
                break;
            default:
                columnasExtra = [];
                break;
        }

        const columnas = [...columnasBase, ...columnasExtra];

        // construir filas
        const filas = (this.datosExport ?? []).map((item) => {
            const fila: any[] = [
                item.kIdAutoEnrolamiento,
                item.entidadFederativa,
                item.sNombreOficial,
                item.sAutoridad,
                item.sSolicitante,
                item.sCorreoInstitucion,
                item.sCorreoSolicitante,
                item.sTelSolicitante,
                item.sObservaciones,
                item.iDocumentos > 0 ? 'Sí' : 'No',
                //...(tipo !== 5 ? [item.fechaRegistro ?? ''] : []),
                ...(tipo !== 5 ? [item.iStatusSolicitud !== 5 ? (item.fechaRegistro ?? '') : ''] : []),
                this.mapearEstatus(item.iStatusSolicitud)
            ];

            if (this.tipoReporteSeleccionado == 4 || this.tipoReporteSeleccionado == 1) {
                let historialFormateado = '';
                if (item.historialEstatus != null) {
                    historialFormateado = item.historialEstatus.replace(/;/g, '\n');
                }
                fila.push(historialFormateado); // Valor de columna usuario revisor
                //fila.push(item.emitirDictaminacion ?? '');
            } else if (this.tipoReporteSeleccionado == 2) {
                let historialformateadodictaminacion = '';

                if (item.sentidoDictaminacion != null){
                    let motivo = '';
                    motivo = item.iStatusSolicitud === 2 ? item.sTextoAdicional : item.sMotivoRechazo;
                    motivo = motivo ?? '';
                    fila.push(item.sentidoDictaminacion + '\nMotivo de la dictaminación: ' + motivo);
                } else {
                    fila.push('');
                }
                //fila.push(item.sentidoDictaminacion ?? '');
                fila.push(item.iStatusSolicitud === 2 ? item.fechaDictamen : item.fechaRechazo);
                if (item.historialEstatus != null) {
                    historialformateadodictaminacion = item.historialEstatus.replace(/;/g, '\n');
                }
                fila.push(historialformateadodictaminacion); // Valor de columna usuario revisor dictaminador
                //fila.push(item.iDocumentos ? 'Sí' : 'No'); // Reenvio de correo
                //fila.push(item.iDocumentoAceptacion ? 'Sí' : 'No'); // Documento aceptacion
            } else if (this.tipoReporteSeleccionado == 0) {
                let historialFormateadoTodas = '';
                //fila.push(item.sentidoDictaminacion ?? '');
                 if (item.sentidoDictaminacion != null){
                    let motivo = '';
                    motivo = item.iStatusSolicitud === 2 ? item.sTextoAdicional : item.sMotivoRechazo;
                    motivo = motivo ?? '';
                    fila.push(item.sentidoDictaminacion + '\nMotivo de la dictaminación: ' + motivo);
                } else {
                    fila.push('');
                }
                fila.push(item.iStatusSolicitud === 2 ? item.fechaDictamen : item.fechaRechazo);
                if (item.historialEstatus != null) {
                    historialFormateadoTodas = item.historialEstatus.replace(/;/g, '\n');
                }
                fila.push(historialFormateadoTodas); // Revisor y dictaminador
                // fila.push(item.iDocumentos ? 'Sí' : 'No'); // Envio correo
                // fila.push(item.iDocumentoAceptacion ? 'Sí' : 'No'); // Documento aceptacion
            }

            return fila;
        });

        return { columnas, filas };
    }

    /**
     * Función para mapear el estatus de la solicitud a un valor legible, se recibe el estatus numérico y se retorna una cadena con el estatus correspondiente según el valor recibido, si el estatus no coincide con ningún caso conocido se retorna 'Desconocido'
     * @param status 
     * @returns 
     */
    public mapearEstatus(status: number): string {
        switch (status) {
            case 1: return 'Pendiente';
            case 2: return 'Dictaminada';
            case 3: return 'Dictaminada';
            case 4: return 'En revisión';
            case 5: return 'Pendiente de Confirmar Correo';
            default: return 'Desconocido';
        }
    }

    public mapearEstatusModalBitacora(status: number): string {
        switch (status) {
            case 1: return 'Pendiente';
            case 2: return 'Dictaminada / Aceptada';
            case 3: return 'Dictaminada / Rechazada';
            case 4: return 'En revisión';
            case 5: return 'Pendiente de Confirmar Correo';
            default: return 'Desconocido';
        }
    }

    /**
     * Función para exportar el reporte a PDF, se preparan los datos de exportación, se formatean las fechas y el tipo de reporte para incluirlos en el título del PDF, se utiliza la librería jsPDF para generar el PDF con un formato específico, incluyendo un título centrado, un rango de fechas, una tabla con los datos del reporte, y números de página en el pie de página, finalmente se guarda el archivo PDF con un nombre basado en el tipo de reporte
     */
    exportarPDF() {
        const { columnas,filas } = this.prepararDatosParaExportar();

        // Fechas y tipo de reporte
        const fechaInicio: Date = new Date(this.formulario.controls['fechaInicio'].value.replace(/-/g, '/'));
        const fechaFin: Date = new Date(this.formulario.controls['fechaFin'].value.replace(/-/g, '/'));
        const tipoReporte = this.formulario.controls['tipo'].value;
        const nombreReporte = this.getNombreReporte(Number(tipoReporte));

        const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'pt',
            format: 'A3'
        });

        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        };

        // --- Título centrado ---
        const titulo = `Reporte ${nombreReporte}`;
        const rangoFechas = `del ${fechaInicio.toLocaleDateString('es-MX', options)} al ${fechaFin.toLocaleDateString('es-MX', options)}`;

        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text(titulo, doc.internal.pageSize.getWidth() / 2, 30, { align: 'center' });

        doc.setFontSize(11);
        doc.setFont('helvetica', 'normal');
        doc.text(rangoFechas, doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' });
        const head: any[] = [];
        const filaAgrupadores: any[] = [];
        const filaSubcolumnas: any[] = [];

        columnas.forEach(col => {
            if (col.subcolumnas) {
                filaAgrupadores.push({ content: col.titulo, colSpan: col.subcolumnas.length, styles: { halign: 'center' } });
                
                col.subcolumnas.forEach((sub: { titulo: string }) => {
                    filaSubcolumnas.push({ content: sub.titulo });
                });
            } else {
                filaAgrupadores.push({ content: col.titulo, rowSpan: 2 });
            }
        });

        head.push(filaAgrupadores);
        if (filaSubcolumnas.length > 0) {
            head.push(filaSubcolumnas);
        }
        // --- Tabla ---
        autoTable(doc, {
            head,
            // head: [
            //     [
            //     { content: 'Dependencia', rowSpan: 2 },
            //     { content: 'Autoridad', rowSpan: 2 },
            //     { content: 'Solicitante', rowSpan: 2 },
            //     { content: 'Datos de contacto', colSpan: 3, styles: { halign: 'center' } },
            //     { content: 'Observaciones Capturadas en la Solicitud', rowSpan: 2 },
            //     { content: 'Documentos', rowSpan: 2 },
            //     { content: 'Estatus', rowSpan: 2 }
            //     ],
            //     [
            //     { content: 'Correo Oficial de la Institución' },
            //     { content: 'Correo Oficial del Solicitante' },
            //     { content: 'Teléfono Institucional del Solicitante' }
            //     ]
            // ],
            body: filas,
            startY: 60, // para que la tabla no se encime con el título
            headStyles: {
                fillColor: [0, 51, 102],
                textColor: [255, 255, 255],
                fontStyle: 'bold',
                halign: 'center',
                valign: 'middle',
                lineWidth: 0.5,
                lineColor: [255, 255, 255]
            },
            styles: {
                halign: 'center',
                valign: 'middle',
                cellWidth: 'wrap',
                overflow: 'linebreak',
                fontSize: 7
            },
            columnStyles: {
                0: { cellWidth: 40, halign: 'center', overflow: 'linebreak' },
                1: { cellWidth: 55, halign: 'center', overflow: 'linebreak' },
                2: { cellWidth: 130, halign: 'justify', overflow: 'linebreak' },
                3: { cellWidth: 110, halign: 'left', overflow: 'linebreak' },
                4: { cellWidth: 90, halign: 'left', overflow: 'linebreak' },
                5: { cellWidth: 85, halign: 'left', overflow: 'linebreak' },
                6: { cellWidth: 85, halign: 'left', overflow: 'linebreak' },
                7: { cellWidth: 70, halign: 'left', overflow: 'linebreak' },
                8: { cellWidth: 130, halign: 'left', overflow: 'linebreak' },
                9: { cellWidth: 55, halign: 'center', overflow: 'linebreak' },
                10: { cellWidth: 55, halign: 'left', overflow: 'linebreak' },
                11: { cellWidth: 80, halign: 'center', overflow: 'linebreak' },
                12: { cellWidth: 70, halign: 'left', overflow: 'linebreak' },
                13: { cellWidth: 60, halign: 'center', overflow: 'linebreak' },
                14: { cellWidth: 60, halign: 'center', overflow: 'linebreak' },
            },
            margin: { top: 20, right: 20, bottom: 30, left: 20 },
            tableWidth: 'auto',
            //pageBreak: 'avoid',

            // didParseCell: (data: any) => {
            // if (data.column.index === 12 && typeof data.cell.raw === 'string' && data.cell.raw.includes('Motivo de la dictaminación')) {
            //     const [label, texto] = data.cell.raw.split(':');
            //     data.cell.richText = [
            //     { text: label + ':', fontStyle: 'bold' }, 
            //     { text: texto } 
            //     ];
            // }
            // },



            didDrawPage: (data) => {
                //const pageStr = `Página ${data.pageNumber} de TOTAL_PAGES`;
                doc.setFontSize(9);
                doc.text(
                    //pageStr,
                    `Página ${data.pageNumber}`,
                    doc.internal.pageSize.getWidth() - 60,
                    doc.internal.pageSize.getHeight() - 20
                );
            }

        });

        const pageCount = doc.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(9);
            doc.text(
                `Página ${i} de ${pageCount}`,
                doc.internal.pageSize.getWidth() - 60,
                doc.internal.pageSize.getHeight() - 20
            );
        }
        doc.save(titulo + '.pdf');
    }



    /**
     * Función para obtener el nombre del reporte según su tipo, se recibe el tipo de reporte como un número y se retorna una cadena con el nombre correspondiente según el valor recibido, si el tipo no coincide con ningún caso conocido se retorna 'Reporte'
     * @param tipo 
     * @returns 
     */
    getNombreReporte(tipo: number): string {
        switch (tipo) {
            case 0: return 'Todas';
            case 1: return 'Pendientes';
            case 2: return 'Dictaminadas';
            case 3: return 'Rechazadas';
            case 4: return 'en revisión';
            case 5: return 'Pendientes de Confirmar Correo';
            default: return 'Reporte';
        }
    }


    /**
     * Función para exportar el reporte a Excel, se preparan los datos de exportación, se formatean las fechas y el tipo de reporte para incluirlos en el título del Excel, se utiliza la librería ExcelJS para generar el archivo Excel con un formato específico, incluyendo un título centrado, un rango de fechas, una tabla con los datos del reporte con estilos personalizados, y se ajusta el ancho de las columnas automáticamente según su contenido, finalmente se guarda el archivo Excel con un nombre basado en el tipo de reporte
     */
    exportarExcel() {
        const { columnas, filas } = this.prepararDatosParaExportar();

        const fechaInicio: Date = new Date(this.formulario.controls['fechaInicio'].value.replace(/-/g, '/'));
        const fechaFin: Date = new Date(this.formulario.controls['fechaFin'].value.replace(/-/g, '/'));
        const tipoReporte = this.formulario.controls['tipo'].value;

        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        };

        const nombreReporte = this.getNombreReporte(Number(tipoReporte));
        const rangoFechas = `del ${fechaInicio.toLocaleDateString('es-MX', options)} al ${fechaFin.toLocaleDateString('es-MX', options)}`;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Reporte');

        // --- Título ---
        worksheet.mergeCells(1, 1, 1, columnas.length);
        const tituloCell = worksheet.getCell(1, 1);
        tituloCell.value = `Reporte ${nombreReporte}`;
        tituloCell.font = { size: 16, bold: true };
        tituloCell.alignment = { horizontal: 'center', vertical: 'middle' };

        // --- Fechas ---
        worksheet.mergeCells(2, 1, 2, columnas.length);
        const fechaCell = worksheet.getCell(2, 1);
        fechaCell.value = rangoFechas;
        fechaCell.font = { size: 12, italic: true };
        fechaCell.alignment = { horizontal: 'center', vertical: 'middle' };

        // --- Encabezados dinámicos ---
        const filaAgrupadores = 3;
        const filaSubcolumnas = 4;
        let colIndex = 1;

        columnas.forEach(col => {
            if (col.subcolumnas) {
                // fusionar celdas para el título agrupador
                worksheet.mergeCells(filaAgrupadores, colIndex, filaAgrupadores, colIndex + col.subcolumnas.length - 1);
                const cell = worksheet.getCell(filaAgrupadores, colIndex);
                cell.value = col.titulo;
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

                // subcolumnas en la fila siguiente
                col.subcolumnas.forEach((sub: { titulo: string }, i: number) => {
                    const subCell = worksheet.getCell(filaSubcolumnas, colIndex + i);
                    subCell.value = sub.titulo;
                    subCell.alignment = { horizontal: 'center', vertical: 'middle' };
                });

                colIndex += col.subcolumnas.length;
            } else {
                // Fusionar verticalmente si no tiene subcolumnas
                worksheet.mergeCells(filaAgrupadores, colIndex, filaSubcolumnas, colIndex);
                const cell = worksheet.getCell(filaAgrupadores, colIndex);
                cell.value = col.titulo;
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
                colIndex++;
            }
        });

        // Estilos para encabezados ---
        [filaAgrupadores, filaSubcolumnas].forEach(fila => {
            const row = worksheet.getRow(fila);
            row.eachCell(cell => {
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '003366' } };
                cell.font = { color: { argb: 'FFFFFF' }, bold: true };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
                cell.border = {
                    top: { style: 'thin', color: { argb: 'FFFFFF' } },
                    left: { style: 'thin', color: { argb: 'FFFFFF' } },
                    bottom: { style: 'thin', color: { argb: 'FFFFFF' } },
                    right: { style: 'thin', color: { argb: 'FFFFFF' } }
                };
            });
        });

        // Datos (a partir de fila 5) ---
        // filas.forEach(fila => {
        //     const row = worksheet.addRow(fila);
        //     row.eachCell(cell => {
        //         cell.alignment = { wrapText: true, vertical: 'top' };
        //     });
        // });
        filas.forEach(fila => {
        const row = worksheet.addRow(fila);
        row.eachCell( cell => {
            cell.alignment = { wrapText: true, vertical: 'top' };

        if (typeof cell.value === 'string' && cell.value.includes('Motivo de la dictaminación')) {
        const [sentido, ...resto] = cell.value.split('\n');
        const motivoCompleto = resto.join('\n');
        
        const index = motivoCompleto.indexOf(':');
        const motivoLabel = motivoCompleto.substring(0, index);
        const motivoTexto = motivoCompleto.substring(index + 1);

        cell.value = {
            richText: [
            { text: sentido + '\n', font: { bold: true } },
            { text: motivoLabel + ': ', font: { bold: true } },
            { text: motivoTexto } 
            ]
                    };
                }
            });
        });


        worksheet.columns.forEach((col, colIndex) => {
            if (colIndex === 6) {
                col.width = 100;
                return;
            }
            let maxLength = 10;
            worksheet.eachRow({ includeEmpty: true }, row => {
                const cellValue = row.getCell(colIndex + 1).value;
                if (cellValue) {
                    const value = cellValue.toString();
                    if (value.length > maxLength) {
                        maxLength = value.length;
                    }
                }
            });
            col.width = Math.min(maxLength + 5, 100);
        });

        workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `Reporte ${nombreReporte}.xlsx`;
            link.click();
        });
    }

    /**
     * Función para abrir el modal de dictaminación, se recibe el ID del movimiento de auto enrolamiento y se configura el modal para mostrar la información correspondiente
     * @param idMovAutoEnrolamiento 
     */
    abrirDictaminacion(idMovAutoEnrolamiento: number): void {
        /*
        this.modalService.open(this.modalDictaminacionTpl, {
            size: 'xl',
            backdrop: 'static',
            keyboard: false,
        });*/
        this.idMovimientoAutoEnrolamiento = idMovAutoEnrolamiento;
        this.isGridVisible = false;
    }

    /**
     * Función para cerrar el modal de dictaminación, se restablece la visibilidad de la grilla y se realiza una búsqueda si es necesario
     * @param event 
     */
    fnCerrarDictaminacion(event: any): void {
        this.isGridVisible = true;
        if (event && (event.id === 2 || event.id === 3)) {
            this.buscar();
        }
    }


    /**
     * Función para reenviar correo de notificación, se recibe el ID del movimiento de auto enrolamiento y se envía el correo correspondiente
     * @param idMovAutoEnrolamiento 
     */
    reenvioCorreo(idMovAutoEnrolamiento: number): void {
        // console.log('reenvio de correo')
        //console.log(idMovAutoEnrolamiento)

        const request: sendEmailRequest =
        {
            Id: idMovAutoEnrolamiento,
            UsuarioId: this.idUsuaurio
        }

        this.service.reenvioCorreo(request)
            .subscribe({
                next: (x: sendEmailResponse) => {
                    if (x.succcess) {
                        this.alertService.info('Reenvío de Correo de Respuesta Exitoso', { autoClose: true, keepAfterRouteChange: false });
                        this.changeDetectorRef.detectChanges();
                    } else {
                        this.alertService.warn('Error al reenviar Correo de Respuesta', { autoClose: true, keepAfterRouteChange: false });
                    }
                },
                error: (err) => {
                    console.error('Error en la petición de reenvío:', err);
                    this.alertService.error('Ocurrió un error inesperado al reenviar el correo', { autoClose: true, keepAfterRouteChange: false });
                }
            });

    }

    /**  
     * Función para reenviar correo de validación, se recibe el ID del movimiento de auto enrolamiento, la autoridad y el correo institucional, se construye la solicitud de reenvío y se envía el correo correspondiente
     */
    reenvioCorreoValidacion(idMovEnrolamiento: number, autoridad: string, correoInstitucional: string): void {
        const request: sendEmailValidacionRequest =
        {
            idAutoEnrolamiento: idMovEnrolamiento,
            autoridad: autoridad,
            correoInstitucion: correoInstitucional
        }

        this.service.reenvioCorreoValidacion(request)
            .subscribe({
                next: (x: sendEmailValidacionResponse) => {
                    if (x.succcess) {
                        this.alertService.info('Reenvío de Correo de Respuesta Exitoso', { autoClose: true, keepAfterRouteChange: false });
                        this.changeDetectorRef.detectChanges();
                    } else {
                        this.alertService.warn('Error al reenviar Correo de Respuesta', { autoClose: true, keepAfterRouteChange: false });
                    }
                },
                error: (err) => {
                    console.error('Error en la petición de reenvío:', err);
                    this.alertService.error('Ocurrió un error inesperado al reenviar el correo', { autoClose: true, keepAfterRouteChange: false });
                }
            });

    }

    /**
     * Función para abrir el modal de revisión, se recibe el ID del movimiento de auto enrolamiento y se configura el modal para mostrar la información correspondiente
     * @param idMovAutoEnrolamiento 
     */
    abrirModalRevision(idMovAutoEnrolamiento: number): void {
        this.idMovAutoEnrolamientoRevision = idMovAutoEnrolamiento;

        this.modalRef = this.modalService.open(this.modalRevisionRegistrosPrendientes, {
            size: 'xl',
            backdrop: 'static',
            keyboard: false,
        });

        this.modalRef.result
            .then(() => {
                this.idMovAutoEnrolamientoRevision = 0;
            })
            .catch(() => {
                this.idMovAutoEnrolamientoRevision = 0;
            });

    }

    /**
     * Función para confirmar la revisión de un registro, se valida que el ID del movimiento de auto enrolamiento sea válido, se construye la solicitud de actualización de estatus a "En Revisión" y se llama al servicio para realizar la actualización, si la actualización es exitosa se muestra un mensaje de éxito y se realiza una nueva búsqueda para actualizar los datos, si ocurre un error durante la actualización se muestra un mensaje de error
     */
    confirmarRevision(): void {
        if (this.idMovAutoEnrolamientoRevision > 0) {

            const request: estatusSolicitudRegistroRequest = {
                idAutoEnrolamiento: this.idMovAutoEnrolamientoRevision,
                idEstatusSolicitud: 4, //  estatus "En Revisión"
                idEmpleado: this.idUsuaurio,
                sIP: this.ip
            };

            this.service.actualizarEstatusSolicitudRegistro(request).subscribe({
                next: (x: estatusSolicitudRegistroResponse) => {
                    if (x.succcess) {
                        this.modalRef?.close();
                        this.alertService.info('Se ha pasado el registro a estatus "En Revisión" ', { autoClose: true, keepAfterRouteChange: false });
                        this.idMovAutoEnrolamientoRevision = 0;

                        setTimeout(() => {
                            this.buscar();
                        }, 2500);
                    }
                    else {
                        this.modalRef?.close();
                        this.alertService.info('No se pudo realizar la actualización del estatus del registro', { autoClose: true, keepAfterRouteChange: false });
                        this.idMovAutoEnrolamientoRevision = 0;
                    }
                },
                error: (err) => {
                    console.error(err);
                    this.modalRef?.close();
                    this.alertService.info('Error al tratar de cambiar el estatus del registro', { autoClose: true, keepAfterRouteChange: false });
                    this.idMovAutoEnrolamientoRevision = 0;
                }
            });
        }
    }

    /**
     * Función para abrir el modal de validación de pendiente, se recibe el ID del movimiento de auto enrolamiento y se configura el modal para mostrar la información correspondiente
     * @param idMovAutoEnrolamiento 
     */
    abrirModalValidaPendiente(idMovAutoEnrolamiento: number): void {
        this.idMovAutoEnrolamientoRevision = idMovAutoEnrolamiento;

        this.modalRef = this.modalService.open(this.modalValPendiente, {
            size: 'xl',
            backdrop: 'static',
            keyboard: false,
        });

        this.modalRef.result
            .then(() => {
                this.idMovAutoEnrolamientoRevision = 0;
            })
            .catch(() => {
                this.idMovAutoEnrolamientoRevision = 0;
            });

    }

    /**
     * Función para confirmar la validación de pendiente, se valida que el ID del movimiento de auto enrolamiento sea válido, se construye la solicitud de actualización de estatus a "Pendiente" y se llama al servicio para realizar la actualización, si la actualización es exitosa se muestra un mensaje de éxito y se realiza una nueva búsqueda para actualizar los datos, si ocurre un error durante la actualización se muestra un mensaje de error
     */
    confirmarPendiente(): void {
        if (this.idMovAutoEnrolamientoRevision > 0) {

            const request: estatusSolicitudRegistroRequest = {
                idAutoEnrolamiento: this.idMovAutoEnrolamientoRevision,
                idEstatusSolicitud: 1, //  estatus "Pendiente"
                idEmpleado: this.idUsuaurio,
                sIP: this.ip
            };

            this.service.actualizarEstatusSolicitudRegistro(request).subscribe({
                next: (x: estatusSolicitudRegistroResponse) => {
                    if (x.succcess) {
                        this.modalRef?.close();
                        this.alertService.info('Se ha pasado el registro a estatus "Pendiente" ', { autoClose: true, keepAfterRouteChange: false });
                        this.idMovAutoEnrolamientoRevision = 0;

                        setTimeout(() => {
                            this.buscar();
                        }, 2500);
                    }
                    else {
                        this.modalRef?.close();
                        this.alertService.info('No se pudo realizar la actualización del estatus del registro', { autoClose: true, keepAfterRouteChange: false });
                        this.idMovAutoEnrolamientoRevision = 0;
                    }
                },
                error: (err) => {
                    console.error(err);
                    this.modalRef?.close();
                    this.alertService.info('Error al tratar de cambiar el estatus del registro', { autoClose: true, keepAfterRouteChange: false });
                    this.idMovAutoEnrolamientoRevision = 0;
                }
            });
        }
    }

    /**
     * Función para abrir el modal de bitácora de estatus, se recibe el ID del movimiento de auto enrolamiento y se configura el modal para mostrar la información correspondiente
     * @param idMovAutoEnrolamiento 
     */
    abrirModalBitacoraEstatus(idMovAutoEnrolamiento: number): void {
        this.service.getBitacoraEstatus(idMovAutoEnrolamiento)
            .subscribe({
                next: (x: BaseReponseGeneric<getBitacoraEstatusResponse[]>) => {
                    if (x.succcess && x.data.length > 0) {
                        this.bitacoraEstatus = x.data;
                        this.modalRef = this.modalService.open(this.modalBitacoraEstatus, {
                            size: 'xl',
                            backdrop: 'static',
                            keyboard: false,
                        });
                    } else {
                        this.alertService.info('No se encontraron registros en la bitácora', { autoClose: true, keepAfterRouteChange: false });
                    }
                },
                error: (err) => {
                    console.error('Error en la consulta de bitácora:', err);
                    this.alertService.error('Ocurrió un error inesperado al consultar la bitácora', { autoClose: true, keepAfterRouteChange: false });
                }
            });
    }

    abrirModalMotivoDictaminacion( idEstatus: number ,motivoAceptacion: string | null, motivoRechazo: string | null): void {
        if (+idEstatus === 2){
            this.motivoDictaminacion = motivoAceptacion;
        } else {
            this.motivoDictaminacion = motivoRechazo;
        }

        this.modalRef = this.modalService.open(this.modalMotivoDictaminacion, {
                            size: 'xl',
                            backdrop: 'static',
                            keyboard: false,
                        });
    }
}


